export interface PatternInformation {
  pattern: RegExp;
  message?: string;
}
